module.exports = __webpack_public_path__ + "static/img/parachute_256.5e00257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parachute_256.png
// module id = TfRe
// module chunks = 0